import React, { useState, useEffect, useRef } from 'react';
import { useStateValue } from './StateProvider.js';
import axios from 'axios';
import configData from './Config';

import Title from './Title.js';
import { transactionsremovalprotection, journalentryremovalprotection } from './Utils/removeprotection.js';
import { getPermission } from './Utils/permissions.js';
import { registerArabicFont } from "./Utils/registerarabicfont.js";
import ReactToPrint from 'react-to-print';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { widgetTypes, renderWidget, renderProperties } from './Utils/widgets.js'

import Select from './Components/select.js';

function Widgets({ state, setState }) {
    const [{ project }, dispatch] = useStateValue();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleCloseModal = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const viewButton = (widget) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <ViewWidget widget={widget} />, modaltype: 'small', modaltitle: 'View Widget' }));
    }

    const addButton = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <AddWidget />, modaltype: 'small', modaltitle: 'Add Widget' }));
    }

    const editButton = (widget) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <EditWidget widget={widget} />, modaltype: 'small', modaltitle: 'Edit Widget' }));
    }

    const removeButton = (widget) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <RemoveWidget widget={widget} />, modaltype: 'small', modaltitle: 'Remove Widget' }));
    }

    function AddWidget() {
        const [orderid, setOrderid] = useState('');
        const [type, setType] = useState('meter');
        const [name, setName] = useState('');
        const [assetid, setAssetid] = useState('');
        const [properties, setProperties] = useState({});

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        const addWidget = () => {
            console.log('Trying to add widget');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Widgets',
                'add',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            if (!name) {
                setResult('Missing info')
                return;
            }

            const trimmedName = name.trim();

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                type: type,
                name: trimmedName,
                orderid: parseInt(orderid),
                assetid: assetid,
            }

            axios.post(configData.CONTROLLERURL + configData.ADDWIDGET, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Add widget data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        data.id = res.data.id;
                        dispatch({
                            type: 'ADD_WIDGET',
                            widget: data
                        });
                        handleCloseModal();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }
        const [widgetValues, setWidgetValues] = useState({});

        const handleChange = (key, value) => {
            setWidgetValues(prev => ({
                ...prev,
                [key]: value
            }));
        };
        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Type</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={widgetTypes} itemid={type} setItemid={setType} />
                        </div>
                        <div className='modal_rowsection'>
                            {renderWidget(type, name)}
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Order ID</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="number"
                                value={orderid}
                                onChange={(e) => setOrderid(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Asset ID</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.assets} itemid={assetid} setItemid={setAssetid} />
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => addWidget()} disabled={loading}>{loading ? 'Loading...' : 'Save'}</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function EditWidget({ widget }) {
        const [id, setId] = useState('');

        const [type, setType] = useState('');
        const [name, setName] = useState('');
        const [orderid, setOrderid] = useState(0);
        const [assetid, setAssetid] = useState('');
        const [properties, setProperties] = useState({});

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            setId(widget.id);
            setType(widget.type);
            setName(widget.name);
            setOrderid(widget.orderid);
            setAssetid(widget.assetid)
        }, [widget]);

        const updateWidget = () => {
            console.log('Trying to update widget');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Widgets',
                'update',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            if (!name) {
                setResult('Missing info')
                return;
            }

            const trimmedName = name.trim();

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id,
                type: type,
                name: trimmedName,
                orderid: parseInt(orderid),
                assetid: assetid,
            }

            axios.post(configData.CONTROLLERURL + configData.UPDATEWIDGET, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Update widget data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'UPDATE_WIDGET',
                            widget: data,
                        });
                        handleCloseModal();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Type</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={widgetTypes} itemid={type} setItemid={setType} />
                        </div>
                        <div className='modal_rowsection'>
                            {renderWidget(type, name)}
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Order ID</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="number"
                                value={orderid}
                                onChange={(e) => setOrderid(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Asset ID</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.assets} itemid={assetid} setItemid={setAssetid} />
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => updateWidget()} disabled={loading}>{loading ? 'Loading...' : 'Update'}</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => removeButton(widget)}>Remove</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function RemoveWidget({ widget }) {
        const [id, setId] = useState('');
        const [type, setType] = useState('');

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            setId(widget.id)
        }, [widget]);

        const removeWidget = () => {
            console.log('Trying to remove widget');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Widgets',
                'remove',
                project.archived
            );
            if (hasPermission.code === 0) {
                setResult(hasPermission.data);
                return;
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id,
            }

            axios.post(configData.CONTROLLERURL + configData.REMOVEWIDGET, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Remove group data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'REMOVE_WIDGET',
                            id: id
                        });
                        handleCloseModal();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_actions'>
                        {result && <div className='modal_result'>{result}</div>}
                        <div className='modal_buttons'>
                            <div className='modal_buttoncontainer'>
                                <button className="modal_button" onClick={() => removeWidget()} disabled={loading}>{loading ? 'Loading...' : 'Remove'}</button>
                            </div>
                            <div className='modal_buttoncontainer'>
                                <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function ViewWidget({ reading }) {
        const [timestamp, setTimestamp] = useState(0);

        const [rows, setRows] = useState([]);

        const [amount, setAmount] = useState(0);

        const printRef = useRef();

        useEffect(() => {
            setTimestamp(reading.ts);
            setRows(reading.rows);
            setAmount(reading.amount);
        }, [reading]);

        const totalAmount = rows.reduce((total, row) => total + (parseFloat(row.reading) || 0), 0);

        return (
            <div className='modal_body'>
                <div className='modal_printable' ref={printRef}>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Project Name</div>
                        </div>
                        <div className='modal_rowsection'>{project.name}</div>
                    </div>
                    <div className='modal_row'>
                        <table className='modal_table'>
                            <thead>
                                <tr>
                                    <th>Asset</th>
                                    <th>Reading</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    rows.map((row, index) => {
                                        const assetName = project.assets.find((ass) => ass.id == row.assetid)?.name;
                                        return (
                                            <tr key={'row' + index}>
                                                <td>{assetName}</td>
                                                <td>{row.reading}</td>
                                            </tr>
                                        )
                                    }
                                    )
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>Total</td>
                                    <td>{totalAmount}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <ReactToPrint
                                trigger={() => (<button className="modal_button">Print</button>)}
                                content={() => printRef.current}
                            />
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='widgets'>
            <Title text='Widgets' />

            <div className='buttonscontainer'>
                <div className='buttonsection'>
                    <button className='button' onClick={addButton}>Add Widget</button>
                </div>
            </div>

            <table className='table'>
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th>ID</th>
                        <th>Order ID</th>
                        <th>Name</th>
                        <th>Type</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        project.widgets
                            .map((widget, index) => {
                                return (
                                    <tr key={'widget' + index}>
                                        <td><div className='table_button' onClick={() => editButton(widget)}>Edit</div></td>
                                        <td><div className='table_button' onClick={() => viewButton(widget)}>View</div></td>
                                        <td><div>{widget.id}</div></td>
                                        <td><div>{widget.orderid}</div></td>
                                        <td><div>{widget.name}</div></td>
                                        <td><div>{widgetTypes.find(widgettype => widgettype.id == widget.type)?.name}</div></td>
                                    </tr>
                                );
                            })
                    }
                </tbody>
            </table>
        </div>
    );
}

export default Widgets;